var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1544 11.8736L6.01091 8.65894L0.867432 11.8736V1.58665C0.867432 1.24562 1.02226 0.918551 1.29786 0.677404C1.57345 0.436256 1.94724 0.300781 2.337 0.300781H9.68483C10.0746 0.300781 10.4484 0.436256 10.724 0.677404C10.9996 0.918551 11.1544 1.24562 11.1544 1.58665V11.8736Z",
    fill: "#3CA48E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeal);
export default __webpack_public_path__ + "static/media/teal.a018b1a3.svg";
export { ForwardRef as ReactComponent };